import { themeAColors } from './variants/themeA';
import { themeBColors } from './variants/themeB';

// A/B Testing Configuration
export type ThemeVariant = 'A' | 'B';

// Get theme variant from localStorage or default to 'B'
export const getThemeVariant = (): ThemeVariant => {
  if (typeof window === 'undefined') return 'B';
  
  const stored = localStorage.getItem('dossiloc_theme_variant');
  if (stored === 'A' || stored === 'B') return stored;
  
  // A/B test assignment: randomly assign users
  const randomVariant = Math.random() < 0.5 ? 'A' : 'B';
  localStorage.setItem('dossiloc_theme_variant', randomVariant);
  
  // Track assignment in analytics if available
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'ab_test_assignment', {
      variant: randomVariant,
      test_name: 'marketing_content_test',
    });
  }
  
  return randomVariant;
};

// Manually set theme variant (for testing or admin override)
export const setThemeVariant = (variant: ThemeVariant): void => {
  localStorage.setItem('dossiloc_theme_variant', variant);
  
  // Track manual override
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'theme_variant_override', {
      variant,
      test_name: 'color_palette_test',
    });
  }
  
  // Reload to apply new theme
  window.location.reload();
};

// Get colors based on current variant
export const getThemeColors = () => {
  const variant = getThemeVariant();
  return variant === 'A' ? themeAColors : themeBColors;
};

// Export for use in theme config
export { themeAColors, themeBColors };
